import { render } from "./new_corpstandart.vue?vue&type=template&id=bf82236a&scoped=true"
import script from "./new_corpstandart.vue?vue&type=script&lang=js"
export * from "./new_corpstandart.vue?vue&type=script&lang=js"

import "../../../assets/style/main.css?vue&type=style&index=0&id=bf82236a&scoped=true&lang=css"
import "../../../assets/style/account.css?vue&type=style&index=1&id=bf82236a&scoped=true&lang=css"
import "../../../assets/style/buttons.css?vue&type=style&index=2&id=bf82236a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bf82236a"

export default script